import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type SetLastViewedPathMutationVariables = Types.Exact<{
  input: Types.SetLastViewedPathInput;
}>;


export type SetLastViewedPathMutation = { __typename?: 'Mutation', setLastViewedPath?: string | null };


export const SetLastViewedPath = /*#__PURE__*/ gql`
    mutation SetLastViewedPath($input: SetLastViewedPathInput!) {
  setLastViewedPath(input: $input)
}
    ` as unknown as DocumentNode<SetLastViewedPathMutation, SetLastViewedPathMutationVariables>;

          

          export const useSetLastViewedPathMutation = (options?:MutationHookOptions<SetLastViewedPathMutation, SetLastViewedPathMutationVariables>) => useMutation(SetLastViewedPath, options);
          

          export type SetLastViewedPathMutationOptions = MutationHookOptions<SetLastViewedPathMutation, SetLastViewedPathMutationVariables>;

          

          export type SetLastViewedPathMutationResult = ReturnType<typeof useSetLastViewedPathMutation>[1];

          
